import useCasMutation, { GenericMutationProps } from './useCasMutation';

type addMutationProps = GenericMutationProps & {
  url: string;
};

export default function useAddMutation({ url, ...rest }: addMutationProps) {
  return useCasMutation({ method: 'post', url, ...rest });
}
